export const lgbtqiaIdentity = [
  { label: 'Bisexual', value: 'bisexual' },
  { label: 'Gay', value: 'gay' },
  { label: 'Lesbian', value: 'lesbian' },
  { label: 'Transgender', value: 'transgender' },
  { label: 'Not Listed', value: 'notListed' },
];
